import { render, staticRenderFns } from "./coreProductPhone.vue?vue&type=template&id=37541ee2&scoped=true"
import script from "./coreProductPhone.vue?vue&type=script&lang=js"
export * from "./coreProductPhone.vue?vue&type=script&lang=js"
import style0 from "./coreProductPhone.vue?vue&type=style&index=0&id=37541ee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37541ee2",
  null
  
)

export default component.exports